import { CloudEnvironmentHealthCheck, ErmDevOpsApiClientService } from 'erm-sdk';

export class HealthCheckViewModel {

    constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService, private healthCheck: CloudEnvironmentHealthCheck) {
    }

    get environmentId(): string | undefined {
        return this.healthCheck.environmentId;
    }

    get serviceName(): string | undefined {
        return this.healthCheck.serviceName;
    }

    result?: string;
    resultTimeUtc?: string;
    elapsedMilliseconds?: number;
    isRunning = false;
    runTitle = 'Run';
    runStatus?: string;

    async run(): Promise<void> {

        if (!this.environmentId || !this.serviceName || this.isRunning) {
            return;
        }

        const startTime = new Date();

        try {
            this.result = '⏳ Running...';
            this.resultTimeUtc = undefined;
            this.runStatus = 'Running...';
            this.isRunning = true;

            const healthCheckReponse = await this.ermDevOpsApiClient.getCloudEnvironmentHealthCheckResult(this.environmentId, this.serviceName);
            const healthCheckResult = healthCheckReponse?.body?.healthCheckResult;
            this.result = healthCheckResult?.isHealthy === true ? '✅ Healthy' : '🔥 Unhealthy';
        }
        catch {
            this.result = '❗ Health Check Failed'
        }
        finally {
            var now = new Date();
            this.resultTimeUtc = now.toISOString();
            this.elapsedMilliseconds = now.getTime() - startTime.getTime();
            this.isRunning = false;
            this.runStatus = undefined;
        }
    }
}
